import React, { Component } from "react";
import { connect } from "react-redux";

import steps from "./stepsMap";
import Stepper from "../../components/Stepper";
import { goNext, goBack } from "../../redux/actions/stepper";
import { goToView, getStarted } from "../../redux/actions/ui";
import { setInfoHelpPage } from "../../redux/actions/infoHelp";
import locale from "../../utils/locale";
import LandingPage from "../../components/LandingPage";
import { notMe } from "../../redux/actions/lot";
import renderIf from "../../utils/renderIf";
import { getSellerCompanyCode } from "../../utils/cbotUtils";
import VerificationPage from "../../components/VerificationPage";
import { getIdFromUrl } from "../../utils/url";
import { getLotDetails, setTotalSteps } from "../../redux/actions/lot";
import CircularProgress from "@material-ui/core/CircularProgress";
import { setVerified } from "../../redux/actions/ui";
import { GOOGLE_ANLYTICS_KEY } from "../../config.uk";
import sendAnalytics, { execute } from "./sendAnalytics";
const renderStep = (activeStepIndex) => {
  let activeStep = steps.find((step) => step.stepIndex === activeStepIndex);
  return (
    <activeStep.stepComponent
      stepFields={activeStep.stepFields}
      key={activeStep.stepIndex}
      stepIntroText={activeStep.stepIntroText}
      stepTitle={activeStep.stepTitle}
    />
  );
};

class PickupForm extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.checkIfFormSubmittedToRedirect();
    execute("VerificationPage", GOOGLE_ANLYTICS_KEY);
  }

  componentDidUpdate(prevProps) {
    this.checkIfFormSubmittedToRedirect();
    sendAnalytics(this.props, prevProps, GOOGLE_ANLYTICS_KEY);
  }

  checkIfFormSubmittedToRedirect = () => {
    if (this.props.formSubmitted) {
      this.props.setInfoHelpPage(
        this.props.statusMessage,
        locale("contactUs", this.props.yardPhoneNumber)
      );
      this.props.goToView("InfoHelpView");
    } else if (this.props.isNotMe) {
      this.props.setInfoHelpPage(locale("inconvenienceMessage"));
      this.props.goToView("InfoHelpView");
    }
  };
  handleVerify = (postCode, vrn) => {
    const urlObj = getIdFromUrl();
    let id;
    if (urlObj.id) {
      if (urlObj.id === "donation") {
        this.props.setTotalSteps(4);
        id = urlObj.parse_url[urlObj.parse_url.length - 2];
      } else {
        id = urlObj.id;
      }
    }

    if (id) {
      this.props.getLotDetails(id, postCode, vrn); //pass both id and entered details
    } else {
      this.props.setInfoHelpPage(locale("noLotIdError"));
      this.props.goToView("InfoHelpView");
    }
  };

  render() {
    const {
      activeStepIndex,
      goNext,
      goBack,
      disableBack,
      disableNext,
      totalSteps,
      fields,
      getStarted,
      onGetStartedClick,
      notMe,
      setVerified,
      apiProcessing,
    } = this.props;
    return (
      <div className="main-container">
        {renderIf(apiProcessing)(<CircularProgress className="load-spinner" />)}
        {renderIf(!setVerified && !apiProcessing)(
          <VerificationPage
            message={this.props.verificationPageMessage}
            text_message={this.props.text_message}
            handleVerify={this.handleVerify}
          />
        )}
        {renderIf(Object.keys(fields).length && setVerified)(
          <div>
            {renderIf(!getStarted)(
              <div className="main-container">
                <LandingPage
                  onGetStartedClick={onGetStartedClick}
                  owner={fields["ownerName"] ? fields["ownerName"].value : ""}
                  seller={
                    fields["sellerName"] ? fields["sellerName"].value : ""
                  }
                  year={
                    fields["vehicleYear"] ? fields["vehicleYear"].value : ""
                  }
                  model={
                    fields["vehicleModel"] ? fields["vehicleModel"].value : ""
                  }
                  make={
                    fields["vehicleMake"] ? fields["vehicleMake"].value : ""
                  }
                  color={
                    fields["vehicleColor"] ? fields["vehicleColor"].value : ""
                  }
                  onNotMeClick={notMe}
                  showNotMe={false}
                  sellerCompanyCode={getSellerCompanyCode(fields) || ""}
                />
              </div>
            )}
            {renderIf(getStarted)(
              <div>
                <div className="main-container">
                  <div className="stepperContent">
                    {renderStep(activeStepIndex)}
                  </div>
                </div>
                <Stepper
                  activeStepIndex={activeStepIndex}
                  totalSteps={totalSteps}
                  disableNext={disableNext}
                  disableBack={disableBack}
                  onBackClick={goBack}
                  onNextClick={goNext}
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeStepIndex: state.stepper.activeStepIndex,
  disableBack: state.stepper.disableBack || state.ui.apiProcessing,
  disableNext: state.stepper.disableNext || state.ui.apiProcessing,
  formSubmitted: state.pickupForm.formSubmitted,
  isNotMe: state.pickupForm.isNotMe,
  statusMessage: state.pickupForm.statusMessage,
  yardPhoneNumber: state.lot.yardPhoneNumber,
  verificationPageMessage: state.lot.verificationPageMessage,
  text_message: state.lot.text_message,
  totalSteps: state.lot.totalSteps,
  fields: state.pickupForm.fields,
  getStarted: state.ui.getStarted,
  setVerified: state.ui.setVerified,
  apiProcessing: state.ui.apiProcessing,
});

const mapDispatchToProps = {
  getLotDetails,
  goNext,
  goBack,
  setInfoHelpPage,
  goToView,
  notMe,
  onGetStartedClick: getStarted,
  setTotalSteps,
};
export default connect(mapStateToProps, mapDispatchToProps)(PickupForm);



// WEBPACK FOOTER //
// ./src/containers/PickupForm/index.uk.js